module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h2>Template</h2>\n<div class="row">\n    <p class="intro danger">\n        Warning!\n    </p>\n    <p class="intro danger">\n        This action will expose your changes made to the experience to the clients.\n    </p>\n</div>\n<div class="row">\n    <div class="control-group">\n        <label class="required description-label">\n            Description of the Template:\n            <input type="text" class="description" placeholder="' +
__e( descriptionPlaceholder ) +
'" autofocus="autofocus" />\n        </label>\n    </div>\n</div>\n\n<div class="actions">\n    <button class="cancel btn btn-secondary">Cancel</button>\n    <button class="ok btn btn-danger ladda-button" data-style="expand-left"></button>\n</div>\n\n<div class="overlay hidden"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/SaveTemplateModalView.tpl
// module id = 2943
// module chunks = 0